import { css } from "@emotion/css";
import { theme } from "../../utils/theme";

export const topicCSS = css`
  font-size: 13px;
  line-height: 1.4rem;
  color: ${theme.palette.blue[60]};
  border: 1px solid ${theme.palette.blue[40]};
  border-radius: 9px;
  display: inline-flex;
  flex-direction: column;
  padding: 7px 11px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #fff;
  gap: 8px;
  flex-basis: 500;

  &:hover,
  &:focus {
    background-color: ${theme.palette.blue[10]};
    border: 1px solid ${theme.palette.blue[50]};
  }

  &:focus {
    box-shadow: 0 0 0 2px ${theme.palette.blue[50]};
    outline: none;
  }

  &:active {
    background-color: ${theme.palette.blue[20]};
  }

  .topic-description {
    color: ${theme.palette.blue[60]};
    font-size: 14px;
  }
`;

export const topicWithDescriptionCSS = css`
  font-size: 16px;
  padding: 15px 11px;
  flex: 1;
  flex-basis: 300px;
`;
